import { Controller, useFormContext } from 'react-hook-form';

import KDSSelect from '@decisiv/ui-components/lib/components/Select';
import { SelectProps } from '@decisiv/ui-components/lib/components/Select/types';
import { ItemOption } from '@decisiv/ui-components/lib/atoms/OptionsList/types';

const Select = ({
  name,
  defaultValue,
  options,
  onChange: externalOnChange,
  ...props
}: SelectProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleChange = (
    id: string | React.FormEvent<HTMLButtonElement>,
    onChange: (value: string) => void,
  ) => {
    /* istanbul ignore next -- @preserve */
    if (typeof id !== 'string') return;

    const selectedOption = options.find((option) => option.id === id);

    const newValue = (selectedOption as ItemOption)?.value ?? '';

    // External onChange is being called before the internal one to be able to get
    // the current value of the field and make computations. Something like `willChange` behavior.
    externalOnChange?.(newValue);
    onChange(newValue);
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <KDSSelect
          value={value}
          name={name}
          options={options}
          onChange={(id) => handleChange(id, onChange)}
          warningMessage={errors[name]?.message?.toString()}
          {...props}
        />
      )}
    />
  );
};

export default Select;
